import _ from 'underscore';
import React, { forwardRef } from 'react';
import {
  Subtitle2, mergeClasses,
} from '@fluentui/react-components';

import { ToolGroupTree } from './types';
import { ToolListItem } from './tools-list-item';
import { useListGroupStyles } from './styles';

interface ToolsListGroupProps {
  group: ToolGroupTree;
}

export const ToolsListGroup = forwardRef<HTMLDivElement, ToolsListGroupProps>(({ group }, ref) => {
  const classes = useListGroupStyles();

  return (
    <div ref={ref} className={mergeClasses('tools-list-group', group.key)}>
      <Subtitle2 className={classes.subtitle} block>
        {group.name}
      </Subtitle2>
      <div>
        {_.map(group.items, (item) => (
          <ToolListItem
            key={item.key}
            tool={item}
          />
        ))}
      </div>
    </div>
  );
});
